import * as actions from './actions'
import initState from './initState'

export { actions }

export const createState = initState